import { styled, makeStyles } from '@material-ui/core';

export const RootComponent = styled('div')({
  width: '100%',
  '&[disabled]': {
    pointerEvents: 'none',
  },
});

export const useInputComponentStyles = makeStyles((theme) => ({
  root: {
    background: theme.palette.xpl.foreground,
    border: `1px solid ${theme.palette.xpl.stoke}`,
    borderRadius: '6px',
    padding: '12px 12px 12px 16px',
    color: theme.palette.xpl.text.primary,
    '&:hover': {
      borderColor: theme.palette.xpl.secondary.default,
    },
  },
  focused: {
    borderColor: theme.palette.xpl.secondary.default,
  },
  error: {
    borderColor: theme.palette.xpl.text.warning,
    '&:hover': {
      borderColor: theme.palette.xpl.text.warning,
    },
  },
  disabled: {
    backgroundColor: theme.palette.xpl.action.disabled,
    borderColor: theme.palette.xpl.stoke,
    color: theme.palette.xpl.text.secondary,
    '&:hover': {
      borderColor: theme.palette.xpl.stoke,
    },
  },
  input: {
    padding: 0,
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0px',
    textAlign: 'left',
    border: 0,
    minWidth: 0,
    '&::placeholder': {
      color: theme.palette.xpl.text.secondary,
    },
  },
}));

export const useInputAdornmentStyles = makeStyles(() => ({
  root: {
    padding: 0,
  },
}));

export const useKeyboardButtonStyles = makeStyles((theme) => ({
  root: {
    padding: 0,
    color: (props) =>
      props.disabled
        ? theme.palette.xpl.text.secondary
        : props.error
        ? theme.palette.xpl.text.primary
        : theme.palette.xpl.text.primary,
    '&[disabled]': {
      color: theme.palette.xpl.text.secondary,
    },
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
}));

export const useErrorMessageStyles = makeStyles((theme) => ({
  root: {
    fontSize: '14px',
    lineHeight: '20px',
    padding: 0,
    marginTop: '4px',
  },
  error: {
    color: `${theme.palette.xpl.text.warning} !important`,
  },
  disabled: {},
}));
